
interface AccountingJournalTemplateGroupHeaderViewDelegate
{
    addConditionDidPress(header:AccountingJournalTemplateGroupHeaderView, group:AccountingJournalGroupTemplate):void;
    addEntryDidPress(header:AccountingJournalTemplateGroupHeaderView, group:AccountingJournalGroupTemplate):void;
}

class AccountingJournalTemplateGroupHeaderView extends UITableViewCell
{
    delegate:AccountingJournalTemplateGroupHeaderViewDelegate = null;

    private titleLabel:MUILabel = null;
    private matchModeComboBox:MUIComboBox = null;
    private addConditionButton:MUIButton = null;
    private addEntryButton:MUIButton = null;

    awakeFromHTML()
    {
        this.titleLabel = MUIOutlet(this, "title-lbl", "MUILabel");

        this.matchModeComboBox = MUIOutlet(this, "match-mode-cb", "MUIComboBox");
        if (this.matchModeComboBox) this.matchModeComboBox.setOnChangeAction(this, function(this:AccountingJournalTemplateGroupHeaderView, control:MUIComboBox, value:string){
            if (this._group != null) this._group.matchMode = parseInt(value);
        });

        this.addConditionButton = MUIOutlet(this, "add-condition-btn", "MUIButton");
        if (this.addConditionButton) this.addConditionButton.setAction(this, function(){
            if (this.delegate && this._group) this.delegate.addConditionDidPress(this, this._group);
        });

        this.addEntryButton = MUIOutlet(this, "add-entry-btn", "MUIButton");
        if (this.addEntryButton) this.addEntryButton.setAction(this, function(){
            if (this.delegate && this._group) this.delegate.addEntryDidPress(this, this._group);
        });

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    // Shown before the group title when several templates are listed at once
    // (the analytic "all" view), so each card says which account owns it.
    titlePrefix:string = null;

    private _group:AccountingJournalGroupTemplate = null;
    set group(group:AccountingJournalGroupTemplate)
    {
        this._group = group;
        let title = group.title ?? MIOLocalizeString("GROUP", "GROUP");
        if (this.titlePrefix != null && this.titlePrefix.length > 0) title = this.titlePrefix + " \u00B7 " + title;
        if (this.titleLabel) this.titleLabel.text = title;
        if (this.matchModeComboBox) this.matchModeComboBox.selectItem(group.matchMode ?? 0);
    }

    get group():AccountingJournalGroupTemplate { return this._group; }
}
